// extracted by mini-css-extract-plugin
export default {"flex_container":"PartnersPageSite_flex_container__crscd","text":"PartnersPageSite_text__2PO1E","img":"PartnersPageSite_img__bVEe2"};